import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import FormHelperText from "@mui/material/FormHelperText";
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';

import api from "../service/api";
import { setError, setSuccess } from "../reducers/appSlice";
import Modal from "../components/Modal";

var validationSchema = Yup.object().shape({
    iniciadores: Yup.string(),
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const ModalNotificar = (props) => {
  const { id, adjuntoId, nombreAdjunto, disabled, iniciadores, actualizarDatos } = props;
  const dispatch = useDispatch();
  const [iniciadoresSeleccionados, setIniciadoresSeleccionados] = useState([]);
  
  const [submitting, setSubmitting] = useState(false);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    setIniciadoresSeleccionados([]);
  };

  const handleClose = () => {
    formik.handleReset();
    setOpen(false);
    props.actualizarDatos();
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    setIniciadoresSeleccionados(
      // On autofill we get a the stringified value.
      typeof value === "string" ? value.split("; ") : value
    );
  };

  const formik = useFormik({
    initialValues: {
        iniciadores: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
          let mailSeleccionados = [];

          for (let index = 0; index < iniciadoresSeleccionados.length; index++) {
            const iniciador = iniciadoresSeleccionados[index];
            let inicioMail = iniciador.indexOf("(");
            let finMail = iniciador.indexOf(")");
            let nombre = iniciador.substr(0, inicioMail);
            let mail = iniciador.substr(
              inicioMail + 1,
              finMail - inicioMail - 1
            );
            mailSeleccionados.push(nombre + "#" + mail);
          }

           let datosAdjunto = new FormData();
           datosAdjunto.append("tra_id", props.id);
           datosAdjunto.append("adjuntoId", props.adjuntoId);
    //       datosAdjunto.append("observacion", values.observacion);
           datosAdjunto.append("nombre_doc", props.nombreAdjunto);
           datosAdjunto.append(
             "notificacion",
             JSON.stringify(mailSeleccionados)
           );

           api
             .notificarAdjuntoTramite(datosAdjunto, {
               headers: {
                 "Content-Type": "multipart/form-data",
               },
             })
             .then((res) => {
               dispatch(setSuccess("Notificaciones enviadas con éxito"));
               formik.handleReset();
               setSubmitting(false);
             })
             .catch((e) => dispatch(setError("Error al intentar enviar las notificaciones.")))             
             .finally(() => {
                setSubmitting(false);
                setOpen(false);
                props.actualizarDatos();
              })
    },
    onReset: () => {
      //
    },
  });

  return (
    <>
      
      <IconButton
        title="Notificar"
        size="small"
        onClick={handleOpen}
        disabled={disabled}
        >
            <ForwardToInboxOutlinedIcon fontSize="small" />
      </IconButton>

      <Modal open={open} handleClose={handleClose} size="md">
        <Typography variant="titulo" sx={{ mb: 1 }}>
          NOTIFICAR
        </Typography>
        <Typography variant="cuerpo" paragraph>
          <b>Adjunto: {nombreAdjunto}</b>
        </Typography>

        <form
          id="formNoti"
          name="formNoti"
          onSubmit={formik.handleSubmit}
          onReset={formik.handleReset}
          noValidate
          autoComplete="off"
        >          
          <Grid container>
            <Grid item lg={12} xs={12}>
              <FormControl
                variant="outlined"
                size="small"
                margin="dense"
                error={
                  formik.touched.notificar &&
                  Boolean(formik.errors.notificar)
                }
                fullWidth
              >
                <InputLabel id="iniciadores">Seleccioná los iniciadores...</InputLabel>
                <Select
                  labelId="iniciadores"
                  id="iniciadores"
                  multiple
                  variant="filled"
                  value={iniciadoresSeleccionados}
                  onChange={handleChange}
                  input={<OutlinedInput label="Seleccioná los iniciadores..." />}
                  renderValue={(selected) => selected.join("; ")}
                  MenuProps={MenuProps}
                >
                  {props.iniciadores.map((iniciador) => (
                    <MenuItem
                      key={iniciador.id}
                      value={
                        iniciador.email !== null
                          ? iniciador.nombre + " (" + iniciador.email + ")"
                          : iniciador.nombre
                      }
                      disabled={iniciador.email === null}
                    >
                      <Checkbox
                        checked={
                          iniciadoresSeleccionados.indexOf(
                            iniciador.email !== null
                              ? iniciador.nombre + " (" + iniciador.email + ")"
                              : iniciador.nombre
                          ) > -1
                        }
                      />
                      <ListItemText>
                        {iniciador.email !== null
                          ? iniciador.nombre + " (" + iniciador.email + ")"
                          : iniciador.nombre}
                      </ListItemText>
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {formik.touched.iniciadores && formik.errors.iniciadores}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>          
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
            }}
          >
            <Button sx={{ m: 1 }} variant="verde" type="submit" disabled={iniciadoresSeleccionados.length===0}>
              {"Notificar"}
            </Button>
            <Button sx={{ m: 1 }} variant="plata" onClick={handleClose}>
              {"Cancelar"}
            </Button>
          </Box>
        </form>
      </Modal>
    </>
  );
};

ModalNotificar.propTypes = {
  adjuntoId: PropTypes.number.isRequired,
  nombreAdjunto: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  iniciadores: PropTypes.string,
};

ModalNotificar.defaultProps = {
  disabled: false,
};

export default ModalNotificar;
